module.exports = __webpack_public_path__ + "img/instagram.c4e9cb46.svg";